import { Link } from 'react-router-dom';

import type { LinkProps } from 'react-router-dom';

import styles from './styles.module.scss';

export enum BUTTON_TYPE {
  DEFAULT = 'default',
  PRIMARY = 'primary',
  ERROR = 'error',
}

export enum BUTTON_MODE {
  BASIC = 'basic',
  OUTLINE = 'outline',
  GHOST = 'ghost',
}

export enum BUTTON_SIZE {
  STANDARD = 'standard',
  ICON_STANDARD = 'icon-standard',
  COMPRESSED = 'compressed',
  ICON_COMPRESSED = 'icon-compressed',
  BIG = 'big',
  ICON_BIG = 'icon-big',
}

export interface IButton {
  type?: BUTTON_TYPE;
  mode?: BUTTON_MODE;
  size?: BUTTON_SIZE;
  fullWidth?: boolean;
  rounded?: boolean;
  linkTo?: LinkProps['to'];
  disabled?: boolean;
  active?: boolean;
  htmlType?: React.ButtonHTMLAttributes<HTMLButtonElement>['type'];
  onClick?: React.MouseEventHandler;
  children?: React.ReactNode;
  className?: string;
}

const Button = ({
  type = BUTTON_TYPE.DEFAULT,
  mode = BUTTON_MODE.BASIC,
  size = BUTTON_SIZE.STANDARD,
  fullWidth = false,
  rounded = false,
  linkTo,
  disabled = false,
  active = false,
  htmlType = 'button',
  onClick,
  children,
  className,
}: IButton) => {
  const buttonClassName = `${styles.container} ${styles[type]} ${styles[mode]} ${styles[size]} ${fullWidth ? styles.fullWidth : ''} 
  ${active ? styles.active : ''} ${rounded ? styles.rounded : ''} ${className || ''}`;

  return linkTo ? (
    <Link onClick={onClick} to={linkTo} className={buttonClassName}>
      {children}
    </Link>
  ) : (
    <button type={htmlType} className={buttonClassName} disabled={disabled} onClick={onClick}>
      {children}
    </button>
  );
};

export default Button;
